import '../style/main.css';
import Meta from '../components/Meta.js';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import Accordion from '../components/Accordion.js';
// An experimental footer image used to emulate the look of the Goliath manual
import testFooter from '../resources/test-footer2.png';

function FAQ() {
  return (
		<>
			<Meta title='FAQ' />
			<Header />
			<div class='main-content'>
				<h2>FAQ</h2>

				<Accordion title='What is HEMA?'>
					<p>
						HEMA stands for Historical European Martial Arts. 
						Simply put it means martial arts that existed in the past in and around the European area. 
						These historical arts are documented in books with text and illustrations showing us how these arts were performed. 
						With those sources at hand we as a community strive to recreate those somewhat lost arts.
					</p>
				</Accordion>

				<Accordion title='Are the swords you use sharp?!?'>
					<p>
						No, when fencing, we are using only swords that are designed for that task, 
						and they are blunt and flexible to lessen the chance of injury to everyone involved. 
						These swords are historically accurate and often designed and built as replicas of 
						the training swords people would have been using 100-500 years ago. For example, 
						Feder or “feather” swords are long sword simulators used historically.
					</p>
				</Accordion>

				<Accordion title='How much does it cost?'>
					<p>
						The first two months of practice are 100% free. 
						After those two months, 
						club members will need to pay for an individual HEMA Alliance (HEMAA) membership, 
						which costs $30 per year, or roughly $2.50 a month.
					</p>
				</Accordion>

				<Accordion title='What do I need to bring when I come to my first practice with Borealis Blades?'>
					<p>
						We encourage you to simply wear what you would for any other gym or workout activity. 
						Gear from the club will be provided for all new members.
					</p>
				</Accordion>
				
				<Accordion title="How do I find where you're practicing each week?">
					<p>
						Join our Facebook group to see our schedule and ask to join our Discord through Facebook to also chat with our other members. 
						These are great places to get other questions answered, too.
					</p>
				</Accordion>

				<Accordion title='How does the club afford space to practice in the winter?'>
					<p>
						During the winter months, we collectively rent a space so we can continue to practice through rain, shine, or snow. 
						We strongly encourage members to donate to the rental fund, but it is not required to practice with us. 
						Suggested donation is $5 per practice, ideally in cash. Our club's goal is to get more people doing more HEMA, 
						and with that in mind, we would never turn anyone away if they can't donate to this fund. 
						Current funds and balance are recorded in a shared document available for club members to review.
					</p>
				</Accordion>

				<Accordion title='Should I purchase all the HEMA gear before showing up for practice?'>
					<p>
						NO, ideally, you will come out and use our club gear at first, 
						so you can discover what size you are for gear before you make any purchases. 
						This will also allow you to handle many different swords from many different manufacturers, 
						so you get one that feels just right for you. 
						The last reason is that members of the HEMAA get discounts at many of the major HEMA retailers in the USA, 
						so often you will save money if you wait and purchase after becoming a full member of the HEMAA.
					</p>
				</Accordion>

				<Accordion title='Do members of your club compete at tournaments?'>
					<p>
						Yes, but they are optional. Over the years, 
						we have had people compete in Longsword, mixed steel, 
						and many other types of tournament events. 
						We also often travel for workshops or longer weekends of training.
					</p>
				</Accordion>

				<Accordion title='How common are injuries?'>
					<p>
						Injuries beyond light bruising are very rare. 
						We gear up for the intensity of the activity we are doing and follow all HEMAA safety guidelines.
					</p>
				</Accordion>
				<img class='footer-img img-center' src={testFooter} />
			</div>
			<Footer />  
		</>
	);
};

export default FAQ;
